/**
 * Is this bundle being served from a hostname sign in can actually work on?
 *
 * Google matches an authorized JavaScript origin exactly. A build served from a
 * hostname the OAuth client does not list gets a sign in that fails inside
 * Google's own UI, with nothing on this page saying why, and the person reading
 * it concludes the panic button is broken.
 *
 * That is not hypothetical here. Every Pages deploy also answers on a
 * `<hash>.vertex-siren.pages.dev` URL that nobody registers, an old hostname
 * keeps resolving for as long as its DNS record exists, and a new front's
 * hostname is live in DNS before anyone remembers to add it to the OAuth client.
 *
 * The valid hostnames are the ones in the product registry, which is also what
 * the Pages Function resolves the product from. Deriving the check from that one
 * list means a new front cannot be legitimate here and unknown there.
 *
 * Browser only, and pure so it can be tested without a DOM.
 */

import { PRODUCTS } from './products';

/**
 * Origins used for local work. They are separate entries on the OAuth client
 * (see the README), so they are not a mismatch worth warning about.
 */
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]', '::1'];

export function hostnameWarning(actualHostname: string): string | null {
  const actual = actualHostname.trim().toLowerCase().replace(/\.$/, '');

  // Nothing to compare against is silence, not a warning.
  if (actual === '') return null;
  if (LOCAL_HOSTNAMES.includes(actual)) return null;
  if (PRODUCTS.some((product) => product.hostname === actual)) return null;

  const known = PRODUCTS.map((product) => product.hostname).join(', ');
  return `Esta página se está sirviendo desde ${actual}, que no es una dirección registrada para el inicio de sesión de Google, así que acá puede fallar. Usá una de estas: ${known}.`;
}
